export enum Sport {
    Basketball = 1,
    Chess = 2,
    Netball = 3,
    Soccer = 4,
    TableTennis = 5,
    Volleyball = 6,
    ElectronicGames = 7
}

export enum sportEmailType {
    teamAwaitingApproval = 0,
    teamApproved = 1
}